export default __webpack_public_path__ + "static/media/trr-drink-wine-sparkling.caab7604.png";